<template>
  <div class="calc-banks">
    <div class="calc-banks__list list" :class="{ 'list--all': isShow }">
      <template v-if="sortedLogos.length">
        <div
          v-for="(logo, idx) in sortedLogos"
          :key="idx"
          :class="{ 'list__item--gtop': logo.is_gtop }"
          class="list__item"
        >
          <img :src="logo.url" alt="logo" loading="lazy" />
        </div>
      </template>

      <template v-else>
        <div
          v-for="(_, idx) in Array.from({ length: 20 })"
          :key="idx"
          class="list__item"
        />
      </template>
    </div>
    <div class="calc-banks__actions actions">
      <button @click="handleShow">
        {{ isShow ? 'Скрыть' : 'Показать еще' }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Logo, Logos } from '@/types/Widget'

interface LocalStorageBank {
  setTime: number
  index: number
  bankId: number
}

export default defineComponent({
  name: 'CalcBanks',
  props: {
    logos: {
      type: Object as () => Logos,
      default: null,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  methods: {
    handleShow: function () {
      this.isShow = !this.isShow
    },
  },
  computed: {
    sortedLogos() {
      if (!this.logos) return []

      let topBank: LocalStorageBank = JSON.parse(
        localStorage.getItem('top-bank') || 'null'
      )

      if (
        !topBank ||
        topBank?.index < 0 ||
        topBank?.setTime > Date.now() + 1000 * 60
      ) {
        const topBanks: number[] = []

        for (let idx in this.logos) {
          if (this.logos[idx].is_gtop) {
            topBanks.push(+idx)
          }
        }

        const randomBank = topBanks[Math.floor(Math.random() * topBanks.length)]
        const indexRandomBank = topBanks.findIndex((el) => randomBank === el)
        const localStorageData: LocalStorageBank = {
          setTime: Date.now(),
          index: indexRandomBank,
          bankId: randomBank,
        }
        localStorage.setItem('top-bank', JSON.stringify(localStorageData))
        topBank = localStorageData
      }

      const sortedLogos: Logo[] = []

      for (let idx in this.logos) {
        if (this.logos[idx].is_gtop && topBank?.bankId === +idx) {
          sortedLogos.unshift(this.logos[idx])
        } else if (this.logos[idx].is_big) {
          if (sortedLogos[0]?.is_gtop) {
            sortedLogos.splice(1, 0, { ...this.logos[idx], is_gtop: false })
          } else {
            sortedLogos.unshift({ ...this.logos[idx], is_gtop: false })
          }
        } else {
          sortedLogos.push(this.logos[idx])
        }
      }

      if (!this.isShow) return sortedLogos.slice(0, 20)
      return sortedLogos
    },
  },
})
</script>

<style lang="scss" scoped>
.calc-banks {
  background-color: #f0f0f0;
  border-radius: 0 0 30px 30px;
  padding: 20px;
}

.list {
  display: grid;
  grid-template-columns: repeat(10, minmax(80px, 1fr));
  gap: 20px 10px;
  overflow: hidden;
  max-height: 220px;
  padding: 20px 0;

  &--all {
    max-height: fit-content;
  }

  &__item {
    height: 80px;
    padding: 15px;
    background: #fff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    &--gtop {
      border: 1px solid #0097ce;
    }

    img {
      height: 100%;
    }
  }
}

.actions {
  display: flex;
  justify-content: end;

  button {
    cursor: pointer;

    font-size: 16px;
    border: none;
    color: #ffffff;
    background-color: #0097ce;
    height: 42px;
    padding: 0 20px;
    border-radius: 16px;
    transition: background-color 0.3s;

    &:hover {
      background-color: #0079a5;
    }
  }
}

@media (max-width: 960px) {
  .list {
    grid-template-columns: repeat(8, minmax(80px, 1fr));
  }
}

@media (max-width: 820px) {
  .list {
    grid-template-columns: repeat(6, minmax(80px, 1fr));
  }
}

@media (max-width: 600px) {
  .list {
    grid-template-columns: repeat(4, minmax(60px, 1fr));
  }
}
</style>
